import { encodeWorkflowMoment, workflowExecutionMoment } from '@/workflow-runner/_pure/workflowMoment';
import type { Moment } from '@/_contract/_~generated/directionMomentSchema';
import type { TraceReplay } from '@/_contract/trace';
import type { TraceSnapshot } from '@/workflow-runner/_contract/traceSnapshot';

export function deriveWorkflowTraceReplay(snapshot: TraceSnapshot): TraceReplay {
    const executions = snapshot.timeline.toolExecutionTickIndexes;
    const initial: Moment = { frames: [], step: { kind: 'initial' } };
    return {
        trace: { adapter: 'workflow-space', traceKind: 'WorkflowTrace', handle: snapshot.selectedTraceHandle, schemaVersion: 1 },
        landmarks: [
            { id: encodeWorkflowMoment(initial), label: 'The workflow is ready for execution.', moment: initial },
            ...executions.map((index, ordinal) => {
                const tick = snapshot.tickTracePoints[index];
                if (!tick || tick.tickKind !== 'tool_execution') throw new Error('Workflow replay position must reference a tool execution.');
                const moment = workflowExecutionMoment(tick.tracePointIndex, ordinal, executions.length);
                return {
                    id: encodeWorkflowMoment(moment),
                    label: `Tool execution at ${tick.stepKey} has settled, including its structural consequences.`,
                    moment,
                };
            }),
        ],
    };
}
